import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class CreateCustomerService {
    async getAppGroupNames(): Promise<string[]> {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/CreateCustomer/appgroupnames`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error("Failed to fetch app group names");
        }

        return await response.json();
    }

    async createCustomer(appGroupName: string, tenantName: string, organisationId?: string) {
        const body: Record<string, string> = { appGroupName, tenantName };
        if (organisationId) {
            body.organisationId = organisationId;
        }

        const response = await getAuthenticatedFetch()(
            `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/CreateCustomer/createcustomer`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            }
        );

        if (!response.ok) {
            const errorData = await response.json().catch(() => null);
            throw new Error(errorData?.errorMessage || "Failed to create customer");
        }

        return await response.json();
    }
}

export default new CreateCustomerService();
